import jwt_decode from "jwt-decode";

export const convertToBoolean = (myString) => {
  if (myString != undefined) {
    let myBool = myString.toString().toLowerCase() === "true";
    return myBool;
  }
};

export const extractRoles = () => {
  let token = localStorage.getItem("token");
  if (token) {
    let decoded = jwt_decode(token);
    if (typeof decoded.role === "string") {
      let arr = [];
      arr.push(decoded.role);
      return arr;
    } else {
      return decoded.role;
    }
  }
};

export const FECHA_NACIMIENTO_MIN = "1900-01-01";

export const obtenerFechaHoyISO = () => {
  const hoy = new Date();
  const mes = String(hoy.getMonth() + 1).padStart(2, "0");
  const dia = String(hoy.getDate()).padStart(2, "0");
  return `${hoy.getFullYear()}-${mes}-${dia}`;
};

export const validarFechaNacimiento = (value, mensaje) => {
  if (!value) return true;
  const fecha = String(value).substring(0, 10);
  if (fecha < FECHA_NACIMIENTO_MIN || fecha > obtenerFechaHoyISO())
    return mensaje || "Fecha de nacimiento inválida";
  return true;
};
